module.exports = __webpack_public_path__ + "img/chrome.56ac21dd.gif";